module.exports = __webpack_public_path__ + "img/ticket2.22a4ca4f.jpg";